import React, { useEffect } from 'react';
import 'vegas/dist/vegas.min.css';


const VegasBackground = () => {
  useEffect(() => {
    const loadVegas = () => {
      return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/vegas/2.4.4/vegas.min.js';
        script.onload = () => resolve();
        document.body.appendChild(script);
      });
    };

    const loadjQuery = () => {
      return new Promise((resolve) => {
        if (window.jQuery) {
          resolve(window.jQuery);
        } else {
          const script = document.createElement('script');
          script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
          script.onload = () => resolve(window.jQuery);
          document.head.appendChild(script);
        }
      });
    };

    loadjQuery()
      .then(($) => loadVegas().then(() => $))
      .then(($) => {
        if ($) {
          $('body').vegas({
            overlay: false,
            transition: 'fade',
            transitionDuration: 4000,
            delay: 10000,
            animation: 'random',
            animationDuration: 20000,
            slides: [
              { src: '../images/bg1.jpg' },
              { src: 'https://m1.behance.net/rendition/pm/6573211/hd/b44a53910c4d7a4474cc59329a585380.jpg' },
              { src: 'https://m1.behance.net/rendition/pm/2941223/hd/cdc4cbb24a2c63c371abddbac6a6bc9f.jpg' },
              { src: 'https://m1.behance.net/rendition/pm/6573211/hd/af996097f7ad732f5a87214a68e3800b.jpg' }
             
            ]
          });
        } else {
          console.error("Vegas is not defined. Make sure jQuery and Vegas are loaded.");
        }
      });

    // Cleanup Vegas on component unmount
    return () => {
      if (window.jQuery && window.jQuery.vegas) {
        window.jQuery('body').vegas('destroy');
      }
    };
  }, []);

  return (
    <div className="container fluid">
      {/* <div className="">
        <h2>King Rayhan</h2>
      </div> */}

      <div className="social_icons text-center">
        <a href="https://www.facebook.com/rayhan095"><i className="fa fa-facebook"></i></a>
        <a href="https://www.twitter.com/rayhan095"><i className="fa fa-twitter"></i></a>
        <a href="https://www.behance.net/rayhan095"><i className="fa fa-behance"></i></a>
        <a href="#"><i className="fa fa-flickr"></i></a>
      </div>
    </div>
  );
};

export default VegasBackground;
